import { signOut } from "@bindery/auth-consumer/browser";
import { Button } from "@bindery/ui/components/ui/button";
import { cn } from "@bindery/ui/lib/utils";
import type { ReactNode } from "react";
import { Link } from "react-router";
import { useSession } from "../data/use-session";
import { ROUTES } from "../routes";

export function Workbench({
  children,
  wide = false,
}: {
  children: ReactNode;
  wide?: boolean;
}) {
  const session = useSession();
  return (
    <div className="bg-desk min-h-dvh print:bg-white">
      <header className="print-hidden bg-background border-b">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3">
          <Link
            to={ROUTES.home}
            className="font-serif text-lg font-semibold tracking-tight"
          >
            Worksheets
          </Link>
          {session.status === "signed-in" && (
            <Button variant="ghost" size="sm" onClick={() => signOut()}>
              Sign out
            </Button>
          )}
        </div>
      </header>
      <main
        className={cn(
          "mx-auto px-4 py-8 print:max-w-none print:p-0",
          wide ? "max-w-5xl" : "max-w-2xl",
        )}
      >
        {children}
      </main>
    </div>
  );
}
